// Explicit foreground/background pairs keep small calendar text readable.
export const appointmentColors = theme => theme.palette.mode === 'dark'
  ? { background: '#28374d', title: '#f1f5f9', detail: '#cbd5e1' }
  : { background: '#f3f6fc', title: '#1f2937', detail: '#475569' };

export const appointmentTooltipSx = {
  bgcolor: theme => appointmentColors(theme).background,
  color: theme => appointmentColors(theme).title,
  border: '1px solid',
  borderColor: 'divider',
  '& .MuiTypography-root': { color: 'inherit', opacity: 1 },
};
